import PemasukanService from '@/services/pemasukan';
import { userHaveRoles } from "@/services/utilities"

export default {
	namespaced: true,
	state: {
	},

	getters: {
	},

	actions: {
		async getPemasukan({ commit, state, getters, dispatch }, page) {
			try {
				let response
				if (userHaveRoles(["accountant"]) || userHaveRoles(["admin"]) || userHaveRoles(["entity"])) {
					response = await PemasukanService.getPemasukanCompanyByCategoryId(page)
				} else {
					response = await PemasukanService.getPemasukanUserByCategoryId(page)
				}
				return response.data ? response.data.data : []
			} catch (e) {
				console.log(e)
			}
		},
		async createPemasukan({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await PemasukanService.createPemasukan({
					...payload,
					type: 'PEMASUKAN'
				});
			} catch (e) {
				console.log(e);
			}
			return response;
		},
		async editDueDateDetail({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await PemasukanService.editDueDate({
					...payload,
					type: 'PEMASUKAN'
				});
			} catch (e) {
				console.log(e);
			}
			return response;
		},
		
		async createBulk({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await PemasukanService.createBulk({
					...payload,
				});
			} catch (e) {
				console.log(e);
			}
			return response;
		},
		async updatePemasukan({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await PemasukanService.updatePemasukan(payload.id, {
					...payload
				})
			} catch (e) {
				console.log(e);
			}
			return response;
		},
		async updateStatusPemasukan({ commit, state, getters, dispatch }, payload) {
			try {
				const response = await PemasukanService.updateStatusPemasukan(payload.id, {
					...payload
				})
				return response
			} catch (e) {
				console.log(e);
			}
		},
		async getPemasukanById({ commit, state, getters, dispatch }, id) {
			try {
				// console.log('id', id)
				let response = await PemasukanService.getPemasukanById(id)
				return response
			} catch (e) {
				console.log(e)
			}
		},
		async getPemasukanByIdPOS({ commit, state, getters, dispatch }, id) {
			try {
				// console.log('id', id)
				let response = await PemasukanService.getPemasukanByIdPOS(id)
				return response
			} catch (e) {
				console.log(e)
			}
		},
		
		async deletePemasukan({ commit, state, getters, dispatch }, id) {
			try {
				await PemasukanService.deletePemasukan(id);
			} catch (e) {

			}
		},
		async filterPemasukan({ commit, state, getters, dispatch }, payload) {
			try {
				let response = await PemasukanService.filterPemasukan(payload)
				return response
			} catch (e) {
				console.log(e)
			}
		},
		async getAttachmentSubmission({ commit, state, getters, dispatch }, id) {
			try {
				let response = await PemasukanService.getAttachmentSubmission(id)
				return response
			} catch (e) {
				console.log(e)
			}
		},
		async uploadSubmissionAttachment({ commit, state, getters, dispatch }, payload) {
			try {
				const response = await PemasukanService.createSubmissionAttachment({
					...payload
				})

				return response
			} catch (e) {
				console.log(e)
			}
		},
		async removeAttachmentSubmission({commit, state, getters, dispatch}, payload) {
			try{
				const response = await PemasukanService.removeAttachmentSubmission(payload);
				return response
			}catch(e){
				console.log(e)
			}
		},
		async deleteRead({ commit, state, getters, dispatch }, payload) {
			let response;
			try {
				response = await PemasukanService.deleteRead(payload);
				return response;
			} catch (e) {
				console.log(e)
			}
			return response;
		},
		// async deletePerson({ commit, state, getters, dispatch }, payload) {
		// 	let response;
		// 	try {
		// 		response = await PemasukanService.deletePerson(payload);
		// 		return response;
		// 	} catch (e) {
		// 		console.log(e)
		// 	}
		// 	return response;
		// },
		async createRead({ commit, state, getters, dispatch }, payload) {
			let response;
			try {
				response = await PemasukanService.createRead({
					...payload
				});
			} catch (e) {
				console.log(e)
			}
			return response;
		},
	},

	mutations: {
		// SET_VALUE_FROM_API(state, payload) {
		// 	state.valueFromApi = payload;
		// }
	}
};
